import { FC, useEffect, useState } from 'react';
import { message, Table, Spin, Tabs } from 'antd';
import { PlanType } from '../../index.d';
import styled from './index.module.scss';
import EfModal from '@/components/UI/Modal';
import Button from '@/components/UI/Button';
import { ChampionLeft, ChampionRight, Champion, SecondRunnerUp, RunnerUp } from '@/components/UI/svg/Referral';
import { useGlobal } from '@/utils/useGlobal';
import { useReferralStore } from '@/components/ReferralHalloween/ReferralProvider';
import type { IRankItem } from '@/components/ReferralHalloween/index.d';
import NextImage from '@/components/NextImage';
import { getCurrentPlanTop } from '@/service/referral';
import EURank from './EURank';
import EfImg from 'elem/ui/ef-img';

const { TabPane } = Tabs;

const RankingList: FC = () => {
    const { useLang, isMobile, useRouter } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('referral');
    const { referralInfo } = useReferralStore();
    const [exhibitList, setexhibitList] = useState<IRankItem[]>([]);
    const [data, setData] = useState<any>({
        current: [],
        last: [],
    });
    const [spin, setSpin] = useState(false);
    const [showReferrals, setShowReferrals] = useState(false);
    const [showRule, setShowRule] = useState(false);
    const [active, setActive] = useState('current');

    const topText = (locale: string, ranking: number) => {
        if (['es', 'mx'].includes(locale)) {
            if (ranking === 1) return t('rankinglist.segundo');
            if (ranking === 2) return t('rankinglist.primero');
            return t('rankinglist.tercero');
        }
        return `${t('rankinglist.top')} ${ranking}`;
    };

    const columns = [
        {
            title: t('rankinglist.th_ranking'),
            dataIndex: 'ranking',
            key: 'ranking',
            align: 'center',
            width: 150,
            render: (val: number) => {
                if (val === 1) return <Champion />;
                if (val === 2) return <RunnerUp />;
                if (val === 3) return <SecondRunnerUp />;
                return val || '--';
            },
        },
        {
            title: t('rankinglist.th_name'),
            dataIndex: 'email',
            key: 'email',
            render: (val: string) => {
                try {
                    return val.split('@')[0];
                } catch {}
                return val;
            },
        },
        {
            title: t('rankinglist.th_success'),
            dataIndex: 'registerCount',
            key: 'registerCount',
            align: 'center',
        },
    ] as any;

    const handleShowRankingList = async () => {
        setSpin(true);
        if (!referralInfo) return;
        try {
            const res = await getCurrentPlanTop(
                {
                    size: 20,
                    planId: referralInfo?.planId,
                    lastMon: 0,
                },
                locale,
            );
            if (res.code !== '0') return message.error(res.message);
            const res1 = await getCurrentPlanTop(
                {
                    size: 20,
                    planId: referralInfo?.planId,
                    lastMon: 1,
                },
                locale,
            );
            setData({
                current: res.data.content,
                last: res1.data.content,
            });
            setSpin(false);
        } catch (error) {}

        setShowReferrals(true);
    };

    useEffect(() => {
        // pc端显示排序调整
        if (!referralInfo || !referralInfo.rankList) return;
        console.log({ referralInfo });
        if (isMobile) {
            setexhibitList(referralInfo.rankList);
        } else {
            const arr = [...referralInfo.rankList];
            const temp = arr.splice(1, 1, arr[0]);
            arr[0] = temp[0];
            setexhibitList(arr);
        }
    }, [referralInfo]);

    const NoData = () => (
        <div className="no-content">
            <div className="no-content-img">
                <NextImage
                    className="pop_topimg"
                    src={require(`@publicLocal/referral/pc/ranking_nothing.png`)}
                    alt={t('rankinglist.pop_leaderboard_title')}
                    aria-label={t('rankinglist.pop_leaderboard_title')}
                />
            </div>
            <p className="no-content-text">{t(active === 'last' ? 'rankinglist.no_data_last' : 'rankinglist.no_data_current')}</p>
        </div>
    );

    const imgs = [
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1748526236161/top_02_PC.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1748526239022/top_02_M.jpg',
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1748526109285/top_01_PC.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1748526112288/top_01_M.jpg',
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1748526242671/top_03_PC.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1748526245755/top_03_M.jpg',
        },
    ];

    if (!referralInfo || !referralInfo.rankList) return <></>;

    return (
        <div className={styled.ranking_list}>
            <h2 className="title">{t('rankinglist.title')}</h2>
            <p className="desc">
                {t.rich('rankinglist.desc', {
                    btn: (text: string) => (
                        <span className="btn" onClick={() => setShowRule(true)}>
                            {text}
                        </span>
                    ),
                })}
            </p>
            <div className="ranking_box">
                {exhibitList.map((item, ind) => (
                    <div
                        key={item.ranking}
                        className={`ranking_card ${item.ranking === 2 && 'second'} ${item.ranking === 1 && 'first'} ${item.ranking === 3 && 'third'}`}
                    >
                        <EfImg pc={imgs[ind].pc} h5={imgs[ind].h5} />
                        <div></div>

                        <p className="top">{topText(locale, item.ranking)}</p>
                        <p className="name">{item.prizeName}</p>
                        <p className="describe">{item.conditionDesc}</p>
                    </div>
                ))}
            </div>
            {['eu', 'uk', 'de', 'fr', 'es', 'it'].includes(locale) && <EURank />}
            <div className="view_more">
                <Button type="link" onClick={handleShowRankingList}>
                    {t('rankinglist.btn')}
                </Button>
            </div>
            <EfModal
                width={640}
                visible={showReferrals}
                open={showReferrals}
                className={`${styled.ranking_modal}`}
                onCancel={() => setShowReferrals(false)}
                maskClosable={isMobile}
                centered={!isMobile}
            >
                <div className="ranking_top">
                    <NextImage
                        className="pop_topimg"
                        src={require(`@publicLocal/referral/${isMobile ? 'h5' : 'pc'}/ranking_pop.png`)}
                        alt={t('rankinglist.pop_title')}
                        aria-label={t('rankinglist.pop_title')}
                    />
                </div>
                <h5 className="title">
                    {referralInfo?.planType === PlanType.CAMPAIGN ? t('rankinglist.pop_leaderboard_c_title') : t('rankinglist.pop_leaderboard_title')}
                </h5>
                <p className="subtitle">{t('rankinglist.pop_leaderboard_desc')}</p>
                {referralInfo?.planType !== 'CAMPAIGN' && (
                    <Tabs className="leaderboard_tabs" activeKey={active} onChange={(val) => setActive(val)} centered>
                        <TabPane tab={t('rankinglist.btn_last')} key="last" />
                        <TabPane tab={t('rankinglist.btn_current')} key="current" />
                    </Tabs>
                )}

                {spin ? (
                    <div style={{ textAlign: 'center', paddingTop: '50px' }}>
                        <Spin />
                    </div>
                ) : data[active].length === 0 ? (
                    <NoData />
                ) : (
                    <Table
                        sticky
                        scroll={{ y: '55vh' }}
                        className="refer_table"
                        rowClassName={(row, i) => `${i % 2 === 1 ? 'odd' : 'even'} ${row.userId ? 'myself' : ''}`}
                        bordered={false}
                        dataSource={data[active]}
                        columns={columns}
                        pagination={false}
                    />
                )}
            </EfModal>
            <EfModal
                width={640}
                visible={showRule}
                open={showRule}
                className={`${styled.rule_modal}`}
                onCancel={() => setShowRule(false)}
                maskClosable={isMobile}
                centered={!isMobile}
            >
                <h5 className="title">{t('rankinglist.pop_rule_title')}</h5>
                <p className="desc" dangerouslySetInnerHTML={{ __html: referralInfo?.rankRuleDesc || '' }}></p>
                {/* <p className="desc">{t('rankinglist.pop_rule_desc1')}</p> */}
                {/* <Button className="btn" onClick={() => setShowRule(false)}>
                    {t('rankinglist.pop_rule_btn')}
                </Button> */}
            </EfModal>
        </div>
    );
};

export default RankingList;
